import { fetchCitiesByCountry } from '../utils/requests'
import { KENNETH_ID, REFERRER, AD_SOURCE, AD_MEDIUM, AD_NAME, DEVICE } from './constants'
import { getValuesFromCookies } from './cookies'
import { getDevice } from './util'
import { asyncPipe } from './common'

export const getBatchQuotesURL = token => {
  const url = window.location.href;
  const isRemarketing = url.includes('remarket_products/');
  const [ baseURL, productURL ] = url.split(isRemarketing ? 'remarket_products/' : 'products/');
  const [ productId ] = productURL.match(/\d+/);
  return `${baseURL}products/${productId}/info_requests/${token}${isRemarketing ? '?remarketing=true' : ''}`;
}

export const buildFormData = (fieldsObj = {}) =>
  Object.entries(fieldsObj).reduce((formData, [key, value]) => {
    formData.append(key, value);
    return formData;
  }, new FormData());

export const prefixInfoRequestFields = fields =>
  Object.entries(fields).reduce((obj, [key, value]) => {
    obj[`info_request[${key}]`] = value
    return obj
  }, {})

export const getFormHiddenFields = medium => {
  const urlParams = new URLSearchParams(window.location.search)
  return {
    [KENNETH_ID]: AD?.CurrentUser?.id || '',
    [REFERRER]: document.referrer,
    [AD_SOURCE]: urlParams.get(AD_SOURCE) || '',
    [AD_MEDIUM]: medium || urlParams.get(AD_MEDIUM) || '',
    [AD_NAME]: urlParams.get(AD_NAME) || '',
    [DEVICE]: getDevice()
  }
}

export const checkUserInfo = async () => {
  const { name, email, branch = '', phone = '' } = await getValuesFromCookies()
  return {
    name: name || AD?.CurrentUser?.full_name || '',
    email: email || AD?.CurrentUser?.email || '',
    branch,
    phone
  }
}

/* Location form helpers */
export const reformatCountriesToOptions = options => options.map(option => ({ label: option[0], value: option[1] }));

export const reformatCitiesToOptions = (options = []) => options.map(option => ({ label: option.to_s, value: option.name, world_city_id: option.id }));

export const getFormattedCities = async countryCode => asyncPipe(fetchCitiesByCountry, reformatCitiesToOptions)(countryCode)

export const checkUserLocation = async (countryOptions = []) => {
  const { country: cookieCountryCode, location: cookieLocation } = await getValuesFromCookies()
  let countryCode, country

  if (countryOptions.length === 1) { // In case product is available only in one country;
    [country] = countryOptions
    countryCode = country.value
  } else {
    countryCode = cookieCountryCode || AFD.countryCode
    country = countryOptions.find(option => option.value === countryCode)
  }
  const locationOptions = (countryCode && country && await getFormattedCities(countryCode)) || []
  const location = (country && cookieLocation && locationOptions.find(option => option.value === cookieLocation)) || {}

  return { country, location, locationOptions }
}

export const getCurrentCountry = countries => countries.find(country => AFD.countryCode === country['value'])